import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../shared/services/superadminusers/auth.service';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  redirectLink: string[] = ['/login'];

  constructor(private router: Router,private _authService: AuthService) { }

  ngOnInit() {
    const userType = localStorage.getItem('user-type');
    if (userType === 'super-admin') {
      this.redirectLink = ['/superadmin/login'];
    }
  }

  // Alternative approach using navigate method
  navigateToHome() {
    if (localStorage.getItem('user-type') === 'super-admin') {
      this._authService.logout();
    } else {      
    this.router.navigate(['/home']);
    }
  }
}